import { Component, Input, ChangeDetectionStrategy, HostBinding } from '@angular/core';

import { Observable } from 'rxjs';

import { AppConstants } from '@fcom/booking/app-constants';

import { BookingSummaryPassenger } from '../../../interfaces/booking-summary.interface';

@Component({
  selector: 'fin-booking-summary-traveler',
  templateUrl: './booking-summary-traveler.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookingSummaryTravelerComponent {
  public readonly C: typeof AppConstants = AppConstants;

  @HostBinding('class.block')
  @HostBinding('class.travelers')
  @HostBinding('class.font-body-1')
  @HostBinding('class.font-body-medium')
  @HostBinding('class.ms-xsmall-y')
  defaultClass = true;

  @Input()
  traveler$: Observable<BookingSummaryPassenger>;

  constructor() {
    /* noop */
  }
}
